import { render, staticRenderFns } from "./HojaFirmasTemplate.vue?vue&type=template&id=711a6f72&scoped=true"
import script from "./HojaFirmasTemplate.vue?vue&type=script&lang=js"
export * from "./HojaFirmasTemplate.vue?vue&type=script&lang=js"
import style0 from "./HojaFirmasTemplate.vue?vue&type=style&index=0&id=711a6f72&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711a6f72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('711a6f72')) {
      api.createRecord('711a6f72', component.options)
    } else {
      api.reload('711a6f72', component.options)
    }
    module.hot.accept("./HojaFirmasTemplate.vue?vue&type=template&id=711a6f72&scoped=true", function () {
      api.rerender('711a6f72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/notificaciones/HojaFirmasTemplate.vue"
export default component.exports